
import { Component, Vue, Prop } from 'vue-property-decorator';
import { getEventList, editEvent, delEvent, getCheckList, setEventCheck, delEventCheck, batchDeleteEvent } from '@/api/orderPolling';
import { UserModule } from '@/store/modules/user';
import DialogAddEvent from './components/selectEventAdd.vue';
import DialogSetImport from '@/views/staff/components/setImport.vue';

@Component({
  name: 'OrderPollingEvent',
  components: {
    DialogAddEvent,
    DialogSetImport
  }
})
export default class extends Vue {
  private formSearch = {
    name: '',
    item: ''
  }

  private dataTable:any = []

  private dialogAddEventVisible = false
  private formEvent = {
    name: ''
  }
  private tableEvent = []
  private pagination = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  }
  created() {
    this.getEventList();
  }
  private setImportVisible=false
  private setImportTitle='导入事件'

  closeImport(value: boolean) {
    this.setImportVisible = value;
    this.getEventList();
  }
  private importEven() {
    this.setImportVisible = true;
  }

  private getProText(row:any) {
    let text = '';
    text = row.state_config === '1' || row.state_config === '2' ? '状态' : '';
    if (text) {
      text += (row.value_config === '1' || row.value_config === '2') ? '、当前值' : '';
    } else {
      text = (row.value_config === '1' || row.value_config === '2') ? '当前值' : '';
    }
    if (text) {
      text += (row.text_config === '1' || row.text_config === '2') ? '、描述' : '';
    } else {
      text = (row.text_config === '1' || row.text_config === '2') ? '描述' : '';
    }
    if (text) {
      text += (row.image_config === '1' || row.image_config === '2') ? '、照片' : '';
    } else {
      text = (row.image_config === '1' || row.image_config === '2') ? '照片' : '';
    }
    return text;
  }
  private search() {
    this.pagination.currentPage = 1;
    this.getEventList()
  }
  private resetSearch() {
    this.formSearch = {
      name: '',
      item: ''
    }
    this.pagination.currentPage = 1;
    this.getEventList()
  }
  private getEventList() {
    let parmars:any = {};
    parmars.user_id = UserModule.getUserId;
    parmars.company_id = UserModule.getCompanyId;
    parmars.page = this.pagination.currentPage;
    parmars.size = this.pagination.pageSize;
    parmars.event_name = this.formSearch.name
    parmars.check_name = this.formSearch.item
    getEventList(parmars).then(res => {
      if (res.data) {
        this.dataTable = res.data.list;
        this.pagination.total = res.data.count;
        for (var i = 0; i < this.dataTable.length; i++) {
          if (this.dataTable[i].child) {
            for (var m = 0; m < this.dataTable[i].child.length; m++) {
              let property = '';
              if (this.dataTable[i].child[m].state_config) {
                property = '状态、';
              }
              if (this.dataTable[i].child[m].value_config) {
                property = property + '当前值、';
              }
              if (this.dataTable[i].child[m].text_config) {
                property = property + '描述、';
              }
              if (this.dataTable[i].child[m].image_config) {
                property = property + '照片、';
              }
              this.dataTable[i].child[m].property = property.substring(0, property.length - 1);
            }
          }
        }
      } else {
        this.pagination.total = 0
        this.dataTable = [];
      }
    }).catch(err => {
      this.pagination.total = 0
      let msg = err.msg;
    });
  }

  private editHandle(row: any) {
    this.$prompt('自定义事件名称：', '编辑自定义事件', {
      inputValue: row.name,
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputErrorMessage: '由1-30个数字、字母、汉字组成的自定义事件名称',
      inputPlaceholder: '请输入自定义事件名称(不超过30字)',
      inputPattern: /^\S.{1,29}$/
    }).then(({ value }: any) => {
      let parmars:any = {};
      parmars.user_id = UserModule.getUserId;
      parmars.company_id = UserModule.getCompanyId;
      parmars.name = value;
      parmars.event_id = row.id;
      editEvent(parmars).then((res:any) => {
        this.showSecussMsg(res.msg);
        this.getEventList();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    });
  }
  private addHandle(val:any) {
    this.setEvent = val;
    this.dialogAddEventVisible = true;
  }

  // 设置
  private dialogSettingCheckVisible = false;
  private formSearchEventCheck = {
    name: ''
  }
  private setEventSearch() {
    this.page = 1;
    this.getCheckList();
  }
  private setEventRest() {
    this.formSearchEventCheck.name = '';
    this.page = 1;
    this.getCheckList();
  }
  private loadmore: any =false
  private SelectedDynamic: any = []
  private tableEventCheck:any = []
  private setEvent:any={}
  private closeHandle(item:any) {
    let index = this.SelectedDynamic.indexOf((aaa:any) => {
      return aaa.id === item.id;
    });
    this.SelectedDynamic.splice(index, 1);
    let index1 = this.selectedbox.indexOf((aaa:any) => {
      return aaa === item.id;
    });
    this.selectedbox.splice(index1, 1);
  }
  private finishHandle() {
    if (!this.SelectedDynamic || this.SelectedDynamic.length < 1) {
      this.showErrorMsg('请选择检查项');
      return;
    }
    let checkids = '';
    this.SelectedDynamic.forEach((element:any) => {
      checkids = checkids + element.id + ',';
    });
    let parmars:any = {};
    parmars.user_id = UserModule.getUserId;
    parmars.company_id = UserModule.getCompanyId;
    parmars.name = this.setEvent.name;
    parmars.event_id = this.setEvent.id;
    parmars.check_list = checkids.substring(0, checkids.length - 1);
    setEventCheck(parmars).then((res:any) => {
      this.dialogSettingCheckVisible = false;
      this.showSecussMsg(res.msg);
      this.getEventList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private setHandle(row:any) {
    this.selectedbox = [];
    this.setEvent = row;
    this.SelectedDynamic = row.child;
    if (this.SelectedDynamic) {
      for (let index = 0; index < this.SelectedDynamic.length; index++) {
        const element = this.SelectedDynamic[index];
        this.selectedbox.push(element.id);
      }
    }
    this.getCheckList();
    this.dialogSettingCheckVisible = true;
  }

  private checkAll = false
  private isIndeterminate:any = null
  private selectedbox:any = []

  private handleCheckAllChange(val: boolean) {
    let options: any = [];
    let selectedDynamic:any = [];
    if (val) {
      for (let i = 0; i < this.tableEventCheck.length; i++) {
        options.push(this.tableEventCheck[i].id);
        selectedDynamic.push(this.tableEventCheck[i]);
      }
    } else {
      options = [];
      selectedDynamic = [];
    }
    this.SelectedDynamic = selectedDynamic;
    this.selectedbox = options;
    this.isIndeterminate = false;
  }
  private handleSelectionChange(checked:boolean, val:any) {
    if (checked) {
      let arr = this.SelectedDynamic.filter((aa:any) => {
        return aa.id === val.id;
      });
      if (!arr || arr.length < 1) { this.SelectedDynamic.push(val); }
    } else {
      let index = this.SelectedDynamic.indexOf((aaa:any) => {
        return aaa.id === val.id;
      });
      this.SelectedDynamic.splice(index, 1);
    }
    let checkedCount = this.selectedbox.length;
    let _length = this.tableEventCheck.length;
    this.checkAll = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }
  private page=1
  private moreHandle() {
    this.page = this.page + 1;
    this.getCheckList();
  }
  private getCheckList() {
    let parmars:any = {};
    parmars.user_id = UserModule.getUserId;
    parmars.company_id = UserModule.getCompanyId;
    parmars.page = this.page;
    parmars.size = 10;
    parmars.check_name = this.formSearchEventCheck.name;
    getCheckList(parmars).then(res => {
      if (res.data) {
        if (this.page >= res.data.page_count) {
          this.loadmore = false;
        } else {
          this.loadmore = true;
        }
        if (this.page === 1) {
          this.tableEventCheck = res.data.list;
        } else {
          this.tableEventCheck = this.tableEventCheck.concat(res.data.list);
        }
      }
    }).catch(err => {
      let msg = err;
    });
  }
  // 批量删除
  private multipleSelection = []
  private tableSelectionChange(val: any) {
    this.multipleSelection = val;
  }
  private groupDelete() {
    if (this.multipleSelection.length === 0) {
      this.showErrorMsg('请选择需要删除的事件');
      return;
    }
    let eventIds = '';
    this.multipleSelection.forEach((ss:any) => {
      eventIds = eventIds + ss.id + ',';
    });
    const h = this.$createElement;
    this.$msgbox({
      title: '',
      message: h('p', [
        h('h3', '确认批量删除此自定义事件? '),
        h('p', { style: 'color: #666666' }, '关联的检查项和下级自定义事件会一起被删除!')
      ]),
      type: 'warning',
      customClass: 'bxgj-message-warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(action => {
      this.batchDeleteEvent(eventIds);
    });
  }
  private batchDeleteEvent(eventIds:any) {
    let parmars:any = {};
    parmars.user_id = UserModule.getUserId;
    parmars.company_id = UserModule.getCompanyId;
    parmars.event_ids = eventIds;
    batchDeleteEvent(parmars).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.getEventList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private deleteHandle(row:any) {
    const h = this.$createElement;
    this.$msgbox({
      title: '',
      message: h('p', [
        h('h3', '确认删除此自定义事件? '),
        h('p', { style: 'color: #666666' }, '关联的检查项和下级自定义事件会一起被删除!')
      ]),
      type: 'warning',
      customClass: 'bxgj-message-warning',
      showCancelButton: true,
      confirmButtonText: '确定',
      cancelButtonText: '取消'
    }).then(action => {
      let parmars:any = {};
      parmars.user_id = UserModule.getUserId;
      parmars.company_id = UserModule.getCompanyId;
      parmars.event_id = row.id;
      delEvent(parmars).then((res:any) => {
        this.showSecussMsg(res.msg);
        this.getEventList();
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    });
  }

  private deleteCurrentHandle(value: any, val:any) {
    this.$confirm('确定删除检查项?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      this.delEventCheck(value, val);
    }).catch(() => {

    });
  }
  private delEventCheck(value:any, val:any) {
    let listQuery:any = {};
    listQuery.user_id = UserModule.getUserId;
    listQuery.company_id = UserModule.getCompanyId;
    listQuery.event_id = value.id;
    listQuery.check_id = val.id;
    delEventCheck(listQuery).then((res:any) => {
      this.showSecussMsg(res.msg);
      this.pagination.currentPage = 1;
      this.getEventList();
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private eventHandle() {
    this.setEvent = {};
    this.dialogAddEventVisible = true;
  }
  private dialogSelectEventAdd(val: any) {
    this.page = 1;
    this.getEventList();
  }
  private closeAddEvent(val: any) {
    this.dialogAddEventVisible = val;
  }

  private handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    this.pagination.currentPage = 1;
    this.getEventList();
  }
  private handleCurrentChange(page:number) {
    this.pagination.currentPage = page;
    this.getEventList();
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
